import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import DesignationRequisitionGroupsModal from './DesignationRequisitionGroupsModal';

class DesignationRequisitionComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      modal_props: false,
      designation_id: this.props.designation_id,
      designation_requisition: this.props.designation_requisition,
    };
    //bind específico
    this.editRequisition = this.editRequisition.bind(this);
    this.closeModalParent = this.closeModalParent.bind(this);

    // Handlers
    this.locale = getLocale();

  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({designation_id: newProps.designation_id});
    this.setState({designation_requisition: newProps.designation_requisition});
  }
  
  editRequisition () {
    this.setState({modal_props: true});
  }

  closeModalParent() {
    this.setState({modal_props: false});
  }


  render() {
    var self = this;
    return (
<div>
    <table className="table">
      <thead>
        <tr>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.Frota}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.Nome}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.Total}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.UmP}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.Motor}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.Similar}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.IFR}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.UmPFrota}
          </th>
          <th>
            {this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.Porte}
          </th>
          <th>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.Excecao}</th>
          <th>{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="requisicoes">
        <tr>
          <td width='100'>
            {self.state.designation_requisition.aircraft_model}
          </td>
          <td width='150'>
            {self.state.designation_requisition.name}
          </td>
          <td width='100'>
            {self.state.designation_requisition.flight_time}
          </td>
          <td width='100'>
            {self.state.designation_requisition.commander_time}
          </td>
          <td width='100'>
            {self.state.designation_requisition.motor_time}
          </td>
          <td width='100'>
            {self.state.designation_requisition.similar_time}
          </td>
          <td width='100'>
            {self.state.designation_requisition.ifr_time}
          </td>
          <td width='100'>
            {self.state.designation_requisition.model_time}
          </td>
          <td width='100'>
            {self.state.designation_requisition.size_time}
          </td>
          <td width='100'>
            {(self.state.designation_requisition.exception === 1) ? 
              <div className="label label-success">{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.SIM}</div>
              :
              <div className="label label-danger">{this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tabela.NAO}</div>
            }
          </td>
          <td width='150'>
            <button className="btn btn-sm btn-primary" value={self.state.designation_requisition.id} onClick={self.editRequisition}>
              <i className="fa fa-fw fa-pencil"></i>
            </button>
            <button className="btn btn-sm btn-danger"  onClick={() => self.props.deleteRequisiton(self.state.designation_requisition.id)}>
              <i className="fa fa-fw fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <DesignationRequisitionGroupsModal handleAlert={self.props.handleAlert} loadData={self.props.loadData} closeModalParent={self.closeModalParent} RequestApi={self.props.RequestApi} designation_requisition={self.state.designation_requisition} designation_requisition_id={self.state.designation_requisition.id} modal_props={self.state.modal_props} designation_requisition_groups={self.state.designation_requisition.groups} certifications_list={self.props.certifications_list} />
</div>
    );
  }
}

export default DesignationRequisitionComponent;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationRequisitionComponent.js